export abstract class ScoreIf {
  abstract getPoints(): number;
  abstract getTotalPoints(): number;
  abstract getWeight(): number;
  abstract getPercent(): number;
}
